
import { defineComponent } from 'vue';
import ApplicationsDropdown from './applications/applications.vue';
import { useAuthStore } from '@/modules/auth/store';
import { useAppRouter } from '@/common/route/useAppRouter';
import { ROUTE_NAME_LOGIN } from '@/modules/login/router';
import { useUiStore } from '@/modules/ui/store';

export default defineComponent({
    name: 'AppHeader',
    components: { ApplicationsDropdown },
    setup() {
        const router = useAppRouter();
        const authStore = useAuthStore();
        const { toggleMenuSidebar } = useUiStore();

        const navbarVariant = process.env.VUE_APP_NAVBAR_VARIANT;

        function logout() {
            authStore.logout();
            router.push({ name: ROUTE_NAME_LOGIN.INDEX });
        }

        return { navbarVariant, toggleMenuSidebar, logout };
    }
});
